import React, { useState, useEffect} from 'react';
import { Container, Row, Col, ListGroup} from 'react-bootstrap';
import Section from '../../../../../Shared/Sections/Section';
import Information from './Information';
import { getSections } from "../../../../../../services/Public/Application/PLS/plsApplication.service";
import { useSelector } from 'react-redux';
import issuesService from '../../../../../../services/Shared/issues.service';

function Index() {
    const [sections, setSections] = useState(null);
    const selector = useSelector(x => x);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const appType = appTypeId == 5 ? "By Comity" : appTypeId == 6 ? "By Exam" : "";
    useEffect(() => {
        getSections().then((response) => {
            issuesService.getIssuesForSections(1, selector.currentApplicationId).then((data) => {
                setSections(selector.currentRoutes != null ? selector.currentRoutes.map((value, i) => {
                    var section = {
                        ...response.filter(x => x.id == value.sectionId)[0]
                    };
                    if (section?.id) {
                        section.link = value.route;
                        var issues = data.data.filter(x => x.sectionId == section.id);
                        if (issues.length) {
                            section.status = `${issues[0].openIssueCount} Issue${issues[0].openIssueCount > 1 ? 's' : ''}`;
                        }
                        return <Section data={section} key={i} />
                    }
                    return;
                }) : []);
            })
        });
    }, [])

    return (
        <div className="plsApplicationIndexPage">
            <Container fluid>
                <strong>Professional Land Surveyor Application {appType}</strong>
                <h4 className="mb-3">Professional Land Surveyor</h4>
                <Row>
                    <Col><Information /></Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <h4 className="mb-3">Sections to Complete</h4>
                        <ListGroup>
                            {sections } 
                        </ListGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Index;